// extracted by mini-css-extract-plugin
module.exports = {"contents":"BaseInstallInterstitial_contents__ScMM6"};